import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Hero copy. It sits on the dark immersive band, so everything here is tuned
// for light-on-dark; the rest of the site stays light.
const FirstSlide = () => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: "24px", maxWidth: "620px" }}>
      <Chip
        label="✨ منصة تعليمية مدعومة بالذكاء الاصطناعي"
        sx={{
          alignSelf: "flex-start",
          fontWeight: 700,
          fontSize: "0.82rem",
          height: "36px",
          paddingInline: "8px",
          color: "#DBEAFE",
          background: "rgba(255,255,255,.08)",
          border: "1px solid rgba(255,255,255,.18)",
        }}
      />

      <Typography
        component="h1"
        sx={{
          fontWeight: 800,
          lineHeight: 1.28,
          letterSpacing: "-0.02em",
          color: "#fff",
          fontSize: { xs: "2.1rem", sm: "2.8rem", md: "3.4rem" },
        }}
      >
        {t("project_title_desc")}
      </Typography>

      <Typography
        sx={{
          color: "rgba(226,232,240,.82)",
          fontSize: { xs: "1rem", md: "1.14rem" },
          lineHeight: 2,
          maxWidth: "560px",
        }}
      >
        {t("project_desc")}
      </Typography>

      <Stack direction="row" sx={{ gap: "14px", flexWrap: "wrap", marginTop: "6px" }}>
        <Button variant="contained" size="large" LinkComponent={Link} to="/exams"
          sx={{ minWidth: "180px", paddingBlock: "13px", fontSize: "1rem" }}>
          {t("exams")}
        </Button>
        <Button
          variant="outlined"
          size="large"
          LinkComponent={Link}
          to="/about-us"
          sx={{
            minWidth: "180px",
            paddingBlock: "13px",
            fontSize: "1rem",
            color: "#fff",
            borderColor: "rgba(255,255,255,.4)",
            "&:hover": { borderColor: "#fff", background: "rgba(255,255,255,.08)" },
          }}
        >
          {t("about_us")}
        </Button>
      </Stack>

      {/* three signals of what the platform actually does */}
      <Stack direction="row" sx={{ gap: { xs: 2.5, md: 4 }, flexWrap: "wrap", marginTop: "18px" }}>
        {[
          { icon: "🧠", title: "أسئلة بالذكاء الاصطناعي" },
          { icon: "🖍️", title: "سبورة تفاعلية مباشرة" },
          { icon: "📊", title: "لوحة أداء لحظية" },
        ].map((feature) => (
          <Stack key={feature.title} direction="row" sx={{ alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 38, height: 38, borderRadius: "12px", display: "grid", placeItems: "center",
                fontSize: "1.1rem", background: "rgba(255,255,255,.08)",
                border: "1px solid rgba(255,255,255,.16)",
              }}
            >
              {feature.icon}
            </Box>
            <Typography sx={{ color: "rgba(226,232,240,.9)", fontWeight: 700, fontSize: "0.88rem" }}>
              {feature.title}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default FirstSlide;
